

export class EcModule {

  ecModuleNum : number;
  libelle : string;

  constructor(){

    this.ecModuleNum = null;
    this.libelle = null;
  }


}



// WEBPACK FOOTER //
// ./src/app/classes/module.ts